module.exports = __webpack_public_path__ + "img/pf.b4386eec.png";